import { Landmark, MapPin, BadgeCheck, FileBadge } from "lucide-react";
import { ORG } from "../data/siteData";

const PILARES = [
  { titulo: "Missão", texto: "Difundir o judô e as artes marciais como instrumento de educação, saúde e cidadania, sem distinção de raça ou credo." },
  { titulo: "Comunidade", texto: "Atendimento preferencial a crianças e jovens da rede pública municipal e de comunidades de Canaã dos Carajás e região." },
  { titulo: "Jita-Kyoei", texto: "Prosperidade e benefício mútuo: o princípio do judô que guia cada treino, projeto e ação social da associação." },
];

export const Sobre = () => (
  <section id="sobre" className="relative bg-[#18181C] py-24 overflow-hidden" data-testid="sobre-section">
    <span aria-hidden className="absolute -left-8 bottom-0 text-[16rem] leading-none font-heading text-white/[0.03] select-none pointer-events-none">禮</span>
    <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
      <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#DC2626] mb-4">Quem Somos</p>
      <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-[#F8FAF8] tracking-tight max-w-2xl" data-testid="sobre-title">
        Uma associação comunitária a serviço do esporte e da cultura
      </h2>
      <p className="mt-6 text-base sm:text-lg text-zinc-400 leading-relaxed max-w-3xl" data-testid="sobre-texto">
        Fundada em {ORG.fundacao}, a {ORG.razaoSocial} ({ORG.sigla}) é uma pessoa jurídica de direito privado, sem fins lucrativos, dedicada a prestar apoio e orientação a crianças, adolescentes, jovens e adultos por meio das artes marciais, do esporte, da cultura e do lazer.
      </p>
      <div className="mt-14 grid sm:grid-cols-3 gap-6">
        {PILARES.map((p, i) => (
          <div key={p.titulo} className="bg-[#202026] border border-white/10 hover:border-[#DC2626]/60 rounded-xl p-6 transition-colors duration-200" data-testid={`sobre-pilar-${i + 1}`}>
            <h3 className="font-heading text-xl font-medium text-[#F8FAF8]">{p.titulo}</h3>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{p.texto}</p>
          </div>
        ))}
      </div>
      <div className="mt-14 bg-[#0F0F11] border border-white/10 rounded-2xl p-8 grid md:grid-cols-2 gap-8" data-testid="sobre-dados-oficiais">
        <div>
          <h3 className="font-heading text-xl font-medium text-[#F8FAF8] flex items-center gap-2"><FileBadge className="h-5 w-5 text-[#DC2626]" /> Identificação Institucional</h3>
          <dl className="mt-5 space-y-3 text-sm">
            <div><dt className="text-zinc-500 uppercase tracking-wider text-xs">Razão Social</dt><dd className="text-zinc-200 mt-1">{ORG.razaoSocial.toUpperCase()}</dd></div>
            <div><dt className="text-zinc-500 uppercase tracking-wider text-xs">CNPJ</dt><dd className="text-zinc-200 mt-1 font-mono">{ORG.cnpj}</dd></div>
            <div><dt className="text-zinc-500 uppercase tracking-wider text-xs">Natureza Jurídica</dt><dd className="text-zinc-200 mt-1">Associação Privada (399-9)</dd></div>
          </dl>
        </div>
        <div>
          <h3 className="font-heading text-xl font-medium text-[#F8FAF8] flex items-center gap-2"><Landmark className="h-5 w-5 text-[#DC2626]" /> Sede</h3>
          <dl className="mt-5 space-y-3 text-sm">
            <div><dt className="text-zinc-500 uppercase tracking-wider text-xs">Endereço</dt><dd className="text-zinc-200 mt-1 flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5 text-[#DC2626] shrink-0" />{ORG.endereco}<br />{ORG.cep}</dd></div>
            <div><dt className="text-zinc-500 uppercase tracking-wider text-xs">Fundação</dt><dd className="text-zinc-200 mt-1">{ORG.fundacao}</dd></div>
            <div className="flex items-center gap-2 text-emerald-400 pt-2"><BadgeCheck className="h-4 w-4" /><span className="text-sm font-medium">Entidade regular e em plena atividade</span></div>
          </dl>
        </div>
      </div>
    </div>
  </section>
);
